import { Table } from '@aws-amplify/ui-react'
import { NavBar } from 'components/NavBar/NavBar'
import { NoItems } from 'components/NoItems-fallback/NoItems'
import { Options } from 'components/Options/Options'
import { Pagination } from 'components/Pagination/Pagination'
import { Td } from 'components/Td/Td'
import useQueryPagination from 'hooks/useQueryPagination'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from 'store'
import { Button, Flex, MainHeadline, PageFooter, PageWrapper, Th, Tr } from 'styling/GlobalStyles'
import { formatDateForDisplay, getParams, handlePagination } from 'utils/helpers'
import { receiptsOptions } from './receiptsData'
import { approveInventoryReceipt, clearReceipts, getInventoryReceipts, rejectInventoryReceipt } from 'features/inventory/inventoryReceiptsSlice'
import { useNavigate } from 'react-router-dom'
import { setConfirmModal } from 'features/global/globalSlice'
import { FilterEnum } from 'components/Filter/SingleFilter'

export const InventoryReceipts = () => {
    const { receipts, totalPages } = useSelector((store: RootState) => store.inventoryReceipts)
    const [params, setParams] = useState<any>(getParams({ location }))
    const dispatch = useDispatch<AppDispatch>()
    const navigate = useNavigate()
    useQueryPagination({ fetchFunctions: [getInventoryReceipts], cleanUpFunctions: [clearReceipts], params })

    const approveReceipt = (id: number) => {
        dispatch(
            setConfirmModal({
                isOpen: true,
                onSave: async () => {
                    await dispatch(approveInventoryReceipt(id))
                },
                word: 'approve this receipt',
            }),
        )
    }

    const rejectReceipt = (id: number) => {
        dispatch(
            setConfirmModal({
                isOpen: true,
                onSave: async () => {
                    await dispatch(rejectInventoryReceipt(id))
                },
                word: 'reject this receipt',
            }),
        )
    }

    const filters = [
        {
            type: FilterEnum.SELECT,
            name: 'Status',
            options: receiptsOptions,
            propName: 'status'
        },
    ]

    return <>
        <NavBar enableTemporaryManualClosing input setParams={setParams} placeholder='Search receipts...' filterOptions={filters} visibleFilterOverflow />
        <PageWrapper>
            <Flex between center mb='16' >
                <MainHeadline>Receipts</MainHeadline>
                <Flex gap='1rem' >
                    <Button orange onClick={() => navigate('add')} >
                        Add Receipt
                    </Button>
                </Flex>

            </Flex>
            {!receipts.length ? (
                <NoItems title='Receipts' />
            ) : (
                <Table width='100%' >
                    <Th>
                        <Td w='13%' noTooltip text='SUPPLIER' />
                        <Td w='13%' noTooltip text='LOCATION' />
                        <Td w='13%' noTooltip text='RECEIPT NUMBER' />
                        <Td w='13%' noTooltip text='RECEIPT DATE' />
                        <Td w='13%' noTooltip text='RECEIPT STATUS' />
                        <Td w='13%' noTooltip text='RECEIPT CURRENCY' />
                        <Td w='17%' noTooltip text='AMOUNT' />
                        <Td w='5%' />
                    </Th>
                    {receipts.map((item) => {
                        return (
                            <Tr view onClick={() => navigate(item.id.toString())} key={item.id}>
                                <Td w='13%' text={item.supplier?.name || '/'} />
                                <Td w='13%' text={item.location?.name || '/'} />
                                <Td w='13%' text={item.receiptNo || '/'} />
                                <Td w='13%' text={formatDateForDisplay(item.receiptDate)} />
                                <Td w='13%' text={receiptsOptions.find(o => o.value == item.status)?.label} />
                                <Td w='13%' text={item.currency || '/'} />
                                <Td w='17%' text={item.totalAmount || '/'} />
                                <Td options w='5%'>
                                    <Options openModal={(approve: boolean) => approve ? approveReceipt(item.id) : rejectReceipt(item.id)} item={item} title='Receipts' />
                                </Td>
                            </Tr>
                        )
                    })}
                </Table>
            )}
        </PageWrapper>
        <PageFooter>
            <Pagination
                setPage={(page) => handlePagination(page, setParams, 30)}
                pageCount={Math.ceil(totalPages)}
                forcePage={(params.page ? params.page : 1) - 1}
            />
        </PageFooter>
    </>
}